module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get_768.ad592d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/fullscreen-image_lets-get_768.png
// module id = kxCm
// module chunks = 0